import { enumDriverStatus } from '@rematter/frontend-lib-api-client';
import { useTranslations } from '@rematter/modules/transportation/i18n/useTranslations';
import { DateField } from '@rematter/ui-web';
import { Radio, RadioGroupField, TextField } from '@rematter/ui-web';
import { useAtomValue, useSetAtom } from 'jotai';

import {
  $driverForm,
  $updateDriverForm,
} from '~/modules/transportation/state/driverForm.localState';

type DriverFormProps = {
  isEditing?: boolean;
};

export const DriverForm = (_props: DriverFormProps) => {
  const t = useTranslations();

  const form = useAtomValue($driverForm);
  const updateForm = useSetAtom($updateDriverForm);

  const handleFieldChange =
    <K extends keyof typeof form>(field: K) =>
    (value: (typeof form)[K]) => {
      updateForm({
        [field]: value,
      });
    };

  return (
    <div className="@DriverForm flex flex-col gap-4">
      <RadioGroupField
        label={t.driversView.form.status}
        // optionType="button"
        // buttonStyle="solid"
        // block
        defaultValue={form.status}
        onChange={(value: string) =>
          handleFieldChange('status')(value as typeof form.status)
        }
        isRequired
      >
        {Object.values(enumDriverStatus).map((status) => (
          <Radio key={status} value={status}>
            {t.driversView.status[status]}
          </Radio>
        ))}
      </RadioGroupField>

      <div className="grid grid-cols-2 grid-rows-1 gap-4">
        <TextField
          label={t.driversView.form.firstName}
          value={form.firstName}
          onChange={handleFieldChange('firstName')}
          isRequired
        />
        <TextField
          label={t.driversView.form.lastName}
          value={form.lastName}
          onChange={handleFieldChange('lastName')}
          isRequired
        />
      </div>

      <div className="grid grid-cols-2 grid-rows-1 gap-4">
        <TextField
          label={t.driversView.form.licenseNumber}
          value={form.licenseNumber}
          onChange={handleFieldChange('licenseNumber')}
          isRequired
        />
        <DateField
          label={t.driversView.form.licenseExpiration}
          value={form.licenseExpiration}
          onChange={(value) =>
            handleFieldChange('licenseExpiration')(value ?? undefined)
          }
        />
      </div>

      <div className="grid grid-cols-2 grid-rows-1 gap-4">
        <TextField
          label={t.driversView.form.phone}
          value={form.phoneNumber}
          onChange={handleFieldChange('phoneNumber')}
          isRequired
        />
        <TextField
          type="email"
          label={t.driversView.form.email}
          value={form.email}
          onChange={handleFieldChange('email')}
          isRequired
        />
      </div>
    </div>
  );
};
